import { render, staticRenderFns } from "./WeSnackBar.vue?vue&type=template&id=0171d0c8&"
import script from "./WeSnackBar.vue?vue&type=script&lang=js&"
export * from "./WeSnackBar.vue?vue&type=script&lang=js&"
import style0 from "./WeSnackBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports